import { Outlet } from 'react-router-dom';

import GetStartedLeadModal from '../components/GetStartedLeadModal';
import { GetStartedModalProvider, useGetStartedModal } from '../context/GetStartedModalContext';
import { useSiteAnalytics } from '../hooks/useSiteAnalytics';
import { useScrollToTop } from '../hooks/useScrollToTop';
import Footer from '../components/Footer';
import HeaderNav from '../components/HeaderNav';

function SiteLayoutContent() {
  useSiteAnalytics();
  useScrollToTop();
  const { show, closeGetStartedModal } = useGetStartedModal();

  return (
    <div className="d-flex flex-column min-vh-100">
      <HeaderNav />
      <main className="flex-grow-1">
        <Outlet />
      </main>
      <Footer />
      <GetStartedLeadModal show={show} onHide={closeGetStartedModal} />
    </div>
  );
}

export default function SiteLayout() {
  return (
    <GetStartedModalProvider>
      <SiteLayoutContent />
    </GetStartedModalProvider>
  );
}
